
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch01Off as ObiSwitch01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-01-off.js';
 
 
 

 
 export const ObiSwitch01Off = createComponent({
   react: React,
   tagName: 'obi-switch-01-off',
   elementClass: ObiSwitch01OffElement,
   events: {
     
   }
  });
 
 